import React from 'react';
import {ReactComponent as Logo} from './logo.svg';
import {ReactComponent as LogoutIcon} from './logout.svg'
import './App.css';
import Endpoints from "./Endpoints";
import Endpoint from "./Endpoint";
import Login from "./Login";
import authService from "./AuthService";
import {BrowserRouter, NavLink, Route, Routes} from "react-router-dom";
import Home from "./Home";
import {ReactComponent as HomeIcon} from "./home.svg";
import {ReactComponent as EndpointIcon} from "./endpoint.svg";
import {ReactComponent as InfluxIcon} from "./influx.svg";
import {ReactComponent as DatabaseIcon} from "./postgres.svg";
import {ReactComponent as GrafanaIcon} from "./grafana.svg";
import {ReactComponent as RedisIcon} from "./Redis.svg";
import {ReactComponent as DocumentationIcon} from "./documentation.svg";
import {ReactComponent as ComponentIcon} from "./component.svg";
import {Toaster} from "react-hot-toast";
import FrameView from "./FrameView";
import config from "./config";
import ApplianceComponents from "./ApplianceComponents";
import ApplianceComponent from "./ApplianceComponent";
import Platforms from "./Platforms";
import Platform from "./Platform";
import HalComponent from "./HalComponent";
import ApplicationComponents from "./ApplicationComponents";
import ApplicationComponent from "./ApplicationComponent";
import Clients from './Clients';
import CoreComponents from "./CoreComponents";
import OidcCallback from "./OidcCallback";

type AppState = {
    loggedIn: boolean
}

class App extends React.Component<{}, AppState> {
    constructor(props: {}) {
        super(props);
        this.state = {
            loggedIn: authService.isLoggedIn()
        }
    }

    render() {
        return (
            <div className="App">
                <BrowserRouter>
                <header className="App-header">
                    <Logo className="App-logo"/>
                    <div className="App-title">Smart Building Cloud</div>
                    {this.state.loggedIn && <div className="App-links">
                        <NavLink className="App-link" to="/"><HomeIcon /><span className="App-link-label">&nbsp;Home</span></NavLink>
                        <NavLink className="App-link" to="/endpoint"><EndpointIcon /><span className="App-link-label">&nbsp;Endpoints</span></NavLink>
                        <NavLink className="App-link" to="/component/core"><ComponentIcon /><span className="App-link-label">&nbsp;Core Components</span></NavLink>
                        <NavLink className="App-link" to="/component/platform"><ComponentIcon /><span className="App-link-label">&nbsp;HAL Components</span></NavLink>
                        <NavLink className="App-link" to="/component/appliance"><ComponentIcon /><span className="App-link-label">&nbsp;Appliance Components</span></NavLink>
                        <NavLink className="App-link" to="/component/application"><ComponentIcon /><span className="App-link-label">&nbsp;Application Components</span></NavLink>
                        <NavLink className="App-link" to="/client"><EndpointIcon /><span className="App-link-label">&nbsp;Clients</span></NavLink>
                        <NavLink className="App-link" to="/influx"><InfluxIcon /><span className="App-link-label">&nbsp;InfluxDB</span></NavLink>
                        <NavLink className="App-link" to="/grafana"><GrafanaIcon /><span className="App-link-label">&nbsp;Grafana</span></NavLink>
                        <NavLink className="App-link" to="/adminer"><DatabaseIcon /><span className="App-link-label">&nbsp;Database</span></NavLink>
                        <NavLink className="App-link" to="/redis"><RedisIcon /><span className="App-link-label">&nbsp;Redis</span></NavLink>
                        <NavLink className="App-link" to="/documentation"><DocumentationIcon /><span className="App-link-label">&nbsp;Documentation</span></NavLink>
                        <div className="spacer"></div>
                        <button className="App-link" onClick={this.logout}><LogoutIcon /></button>
                    </div>}
                </header>
                <Routes>
                    {/* OIDC Callback Route - accessible regardless of login state */}
                    <Route 
                        path="/auth/callback" 
                        element={<OidcCallback onLoginSuccess={() => this.setState({loggedIn: true})} />}
                    />
                    
                    {/* Protected Routes */}
                    {authService.isLoggedIn() ? (
                        <>
                            <Route path="/" element={<Home/>}/>
                            <Route path="/endpoint" element={<Endpoints/>}/>
                            <Route path="/endpoint/:endpointId" element={<Endpoint/>}/>
                            <Route path="/component/appliance" element={<ApplianceComponents/>}/>
                            <Route path="/component/appliance/:imageReference/:version" element={<ApplianceComponent/>}/>
                            <Route path="/component/application" element={<ApplicationComponents/>}/>
                            <Route path="/component/application/:imageReference/:version" element={<ApplicationComponent/>}/>
                            <Route path="/component/platform" element={<Platforms/>}/>
                            <Route path="/component/core" element={<CoreComponents/>}/>
                            <Route path="/component/platform/:name" element={<Platform/>}/>
                            <Route path="/component/platform/hal/:halId" element={<HalComponent/>}/>
                            <Route path="/client" element={<Clients/>}/>
                            <Route path="/influx" element={<FrameView src={config.InfluxUrl}/>}/>
                            <Route path="/grafana/" element={<FrameView src={config.GrafanaUrl}/>}/>
                            <Route path="/adminer" element={<FrameView src={config.AdminerUrl}/>}/>
                            <Route path="/redis" element={<FrameView src={config.RedisUrl}/>}/>
                            <Route path="/documentation" element={<FrameView src={config.DocumentationUrl}/>}/>
                        </>
                    ) : (
                        <Route path="*" element={<Login loggedCallback={() => this.setState({loggedIn: authService.isLoggedIn()})}/>}/>
                    )}
                </Routes>
                </BrowserRouter>
                <Toaster position="top-right" containerStyle={{
                    top: '80px',
                }} toastOptions={{
                    style: {
                        borderRadius: '8px',
                        background: '#282828',
                        color: '#aaa',
                        border: '1px solid #444',
                    }
                }}/>
            </div>
        );
    }

    logout = () => {
        authService.logout();
        this.setState({loggedIn: false});
    }
}

export default App;
